import { Box } from '@skin-seoul/design-system';
import { BeforeAfterSlider } from '@skin-seoul/shared-components';
import { HiddenGemSection } from '@skin-seoul/shared-components';
import { AmazonSection } from '@skin-seoul/shared-components';

const GGUCampaignSection = () => {
  return (
    <Box
      width="100%"
      background="#ffffff"
      boxSizing="border-box"
      maxWidth={{
        base: '100%',
        tablet: '1280px',
      }}
      margin={{
        base: 0,
        tablet: '0 auto',
      }}
    >
      <BeforeAfterSlider
        content={{
          rightSection: <HiddenGemSection />,
          leftSection: <AmazonSection />,
        }}
      />
    </Box>
  );
};

export default GGUCampaignSection;
